const skeletonPropDefs = {
    loading: { type: 'boolean', default: true },
};
export { skeletonPropDefs };
//# sourceMappingURL=skeleton.props.js.map